import React from 'react';
import { makeStyles } from "@material-ui/core/styles";
import FlagstoneTheme from '../../config/flagstoneTheme';

export default function ActionButton(props) {

    const classes = useStyles();   

    return (
        <button className={classes.actionButton} disabled = {props.disabled} onClick={() => props.action()}>{props.text}</button>
    );
}


const useStyles = makeStyles(() => ({
    actionButton:{       
        cursor: "pointer",
        color:"white",
        border:"none",
        outline:"none",
        height:"40px",
        width:"60px",
        backgroundColor: FlagstoneTheme.palette.primary.main,        
        margin: "10px",
        fontWeight:"bold",
        fontSize: "14px",
        fontFamily: "Lato, sans-serif",
    }

}));
